<hard-modal
  [title]="(data.item ? 'htEdit' : 'base.add') | hardTranslate"
  [actions]="actionsTemplate"
  (closeModal)="close()"
>
  @if (loading) {
    <hard-loading></hard-loading>
  } @else if (gridFields.length) {
    <div
      class="guide-modal-content"
      [formGroup]="form"
    >
      <!-- Role Selection Dropdown -->
      <div class="role-select-wrap">
        <hard-form-grid
          [form]="form"
          [config]="{
            params: {
              direction: 'column',
              fields: gridFields,
            },
          }"
        ></hard-form-grid>
      </div>

      <!-- Upload Columns -->
      <div class="upload-columns">
        <!-- Left Column: Video Instruction -->
        <div class="column video-column">
          <h3 class="column-title">
            {{ "dicTable.addVideoInstruction" | hardTranslate }}
          </h3>

          <div
            class="video-upload-box"
            (click)="videoInput.click()"
          >
            <span class="icon-download upload-icon"></span>
            <div class="upload-text-wrap">
              <span class="upload-main-text">
                {{ "dicTable.uploadVideo" | hardTranslate }}
              </span>
              <span class="upload-sub-text">MOV, MP4</span>
            </div>
          </div>
          <input
            #videoInput
            type="file"
            accept="video/mp4,video/quicktime"
            hidden
            (change)="onVideoSelected($event)"
          />

          <!-- Video Player / Local Preview -->
          <div class="video-player-container">
            @if (videoUploading()) {
              <div class="video-loader">
                <hard-loading></hard-loading>
              </div>
            } @else if (videoSrc()) {
              <div class="video-player-wrapper">
                <video
                  [src]="videoSrc()"
                  controls
                  class="video-element"
                ></video>
                <button
                  type="button"
                  class="video-delete-btn"
                  (click)="removeVideo()"
                >
                  <span class="icon-clear"></span>
                </button>
              </div>
            }
          </div>
        </div>

        <!-- Right Column: PDF Instructions -->
        <div class="column pdf-column">
          <h3 class="column-title">
            {{ "dicTable.addPdfInstruction" | hardTranslate }}
          </h3>

          <!-- KZ Row -->
          <div class="pdf-row">
            <span class="pdf-lang-label">
              {{ "base.shortKz" | hardTranslate }}
            </span>
            <div class="pdf-row-controls">
              <div
                class="pdf-upload-btn"
                (click)="kzPdfInput.click()"
              >
                <span class="icon-download pdf-upload-icon"></span>
                <div class="pdf-upload-text">
                  <span class="pdf-main-text">
                    {{ "dicTable.uploadPdf" | hardTranslate }}
                  </span>
                  <span class="pdf-sub-text">PDF</span>
                </div>
              </div>
              <input
                #kzPdfInput
                type="file"
                accept="application/pdf"
                hidden
                (change)="uploadPdf($event, LangEnum.KZ)"
              />

              <div class="pdf-status-container">
                @if (kzUploading()) {
                  <div class="pdf-status-box">
                    <hard-loading></hard-loading>
                  </div>
                } @else if (form.get("kzDocumentUrl")?.value) {
                  <div class="pdf-status-box pdf-status-box--loaded">
                    <div class="pdf-info">
                      <span class="icon-docs pdf-doc-icon"></span>
                      <span class="pdf-doc-name">
                        {{ "dicTable.pdfKzInstruction" | hardTranslate }}
                      </span>
                    </div>
                    <button
                      type="button"
                      class="pdf-delete-btn"
                      (click)="removePdf(LangEnum.KZ)"
                    >
                      <span class="icon-clear"></span>
                    </button>
                  </div>
                } @else {
                  <div class="pdf-status-box pdf-status-box--empty">
                    <span>{{ "dicTable.pdfNotUploaded" | hardTranslate }}</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- RU Row -->
          <div class="pdf-row">
            <span class="pdf-lang-label">
              {{ "base.shortRu" | hardTranslate }}
            </span>
            <div class="pdf-row-controls">
              <div
                class="pdf-upload-btn"
                (click)="ruPdfInput.click()"
              >
                <span class="icon-download pdf-upload-icon"></span>
                <div class="pdf-upload-text">
                  <span class="pdf-main-text">
                    {{ "dicTable.uploadPdf" | hardTranslate }}
                  </span>
                  <span class="pdf-sub-text">PDF</span>
                </div>
              </div>
              <input
                #ruPdfInput
                type="file"
                accept="application/pdf"
                hidden
                (change)="uploadPdf($event, LangEnum.RU)"
              />

              <div class="pdf-status-container">
                @if (ruUploading()) {
                  <div class="pdf-status-box">
                    <hard-loading></hard-loading>
                  </div>
                } @else if (form.get("ruDocumentUrl")?.value) {
                  <div class="pdf-status-box pdf-status-box--loaded">
                    <div class="pdf-info">
                      <span class="icon-docs pdf-doc-icon"></span>
                      <span class="pdf-doc-name">
                        {{ "dicTable.pdfRuInstruction" | hardTranslate }}
                      </span>
                    </div>
                    <button
                      type="button"
                      class="pdf-delete-btn"
                      (click)="removePdf(LangEnum.RU)"
                    >
                      <span class="icon-clear"></span>
                    </button>
                  </div>
                } @else {
                  <div class="pdf-status-box pdf-status-box--empty">
                    <span>{{ "dicTable.pdfNotUploaded" | hardTranslate }}</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- EN Row -->
          <div class="pdf-row">
            <span class="pdf-lang-label">
              {{ "base.shortEng" | hardTranslate }}
            </span>
            <div class="pdf-row-controls">
              <div
                class="pdf-upload-btn"
                (click)="enPdfInput.click()"
              >
                <span class="icon-download pdf-upload-icon"></span>
                <div class="pdf-upload-text">
                  <span class="pdf-main-text">
                    {{ "dicTable.uploadPdf" | hardTranslate }}
                  </span>
                  <span class="pdf-sub-text">PDF</span>
                </div>
              </div>
              <input
                #enPdfInput
                type="file"
                accept="application/pdf"
                hidden
                (change)="uploadPdf($event, LangEnum.EN)"
              />

              <div class="pdf-status-container">
                @if (enUploading()) {
                  <div class="pdf-status-box">
                    <hard-loading></hard-loading>
                  </div>
                } @else if (form.get("enDocumentUrl")?.value) {
                  <div class="pdf-status-box pdf-status-box--loaded">
                    <div class="pdf-info">
                      <span class="icon-docs pdf-doc-icon"></span>
                      <span class="pdf-doc-name">
                        {{ "dicTable.pdfEnInstruction" | hardTranslate }}
                      </span>
                    </div>
                    <button
                      type="button"
                      class="pdf-delete-btn"
                      (click)="removePdf(LangEnum.EN)"
                    >
                      <span class="icon-clear"></span>
                    </button>
                  </div>
                } @else {
                  <div class="pdf-status-box pdf-status-box--empty">
                    <span>{{ "dicTable.pdfNotUploaded" | hardTranslate }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <hard-no-data></hard-no-data>
  }
</hard-modal>

<ng-template #actionsTemplate>
  <div class="flex justify-end gap-2">
    <hard-button
      type="muted"
      (click)="close()"
    >
      {{ "base.cancel" | hardTranslate }}
    </hard-button>
    <hard-button
      [disabled]="saving || form.invalid"
      [loading]="saving"
      (click)="save()"
    >
      {{ (data.item ? "base.save" : "base.add") | hardTranslate }}
    </hard-button>
  </div>
</ng-template>
